namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_table, {
		width: '100%',
		height: '100%',
		minWidth: 0,
		minHeight: 0,
		overflow: 'hidden',
	} )
}
